import styled from 'styled-components';
import { CFBaseSearchbarStyles, } from '@connectrn/ds-ui-base';
export const CFSearchbarElements = {
    ClearButtonWrapper: styled.div `
    ${CFBaseSearchbarStyles.ClearButtonWrapper}
    ${CFBaseSearchbarStyles.ClearButtonWrapperWeb}
  `,
    Input: styled.input `
    ${CFBaseSearchbarStyles.Input}
    ${CFBaseSearchbarStyles.InputWeb}
  `,
    Root: styled.div `
    ${CFBaseSearchbarStyles.Root}
    ${CFBaseSearchbarStyles.RootWeb}
  `,
    SearchIconWrapper: styled.div `
    ${CFBaseSearchbarStyles.SearchIconWrapper}
    ${CFBaseSearchbarStyles.SearchIconWrapperWeb}
  `,
};
